import { FC, useState } from "react";
import { ReactComponent as ShareIcon } from "../../../../assets/actions/share-arrow-right.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/actions/chevron-up.svg";
import { ReactComponent as CommentsIcon } from "../../../feed/assets/comments.svg";
import { ShareContentModalWindow } from "@/components/ShareModalWindow/ShareContentModalWindow";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Author, singleNewsOverviewTypes } from "../../types/NewsTypes";
import { createToast } from "@/utils/toaster/createToast";
import { Button, Card, Dialog, Flex, Tooltip } from "@radix-ui/themes";
import { ChatBubbleIcon, CopyIcon, Share1Icon } from "@radix-ui/react-icons";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import i18next from "i18next";
import { SingleNewsAuthorActions } from "./SingleNewsAuthorActions";
export const SingleNewsActions: FC<{
  data: singleNewsOverviewTypes & {
    author: Author;
  };
}> = ({ data }) => {
  const [shareModalOpen, setShareModalOpen] = useState<boolean>(false);
  const currentUser = useCurrentUserProfile((s) => s.user);
  const scrollToComments = () => {
    // Get the element with the class "comment"
    const commentElement = document.querySelector(".base-input");

    // Check if the element exists
    if (commentElement) {
      // Scroll to the element
      commentElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <Dialog.Root>
      {/* Modal for sharing news */}
      <ShareContentModalWindow
        sharedFrom={"news"}
        createType="create"
        show={shareModalOpen}
        closeWindow={() => setShareModalOpen(false)}
        postData={{
          uid: currentUser.uid,
          postText: "",
          postedIn: "",
          totalSharesNumber: 0,
          postVideo: "",
          created: data.created,
          postPhoto: "",
          wasEdited: false,
          commentsCount: 0,
          totalLikesNumber: 0,
          totalCommentsNumber: 0,
          id: data.slug,
          authorSlug: currentUser.slug,
          authorUsername: currentUser.userName,
          authorLogo: currentUser.profileLogoUrl,
          hasCurrentUserLikedThisPost: false,
          type: "sharedNews",
          additionalData: data,
        }}
      />

      <Flex gap="3" direction="column">
        <Card>
          <Flex wrap="wrap" gap="2" justify="center" align="center">
            {/* Copy Link */}
            <Tooltip content={i18next.t("news.actions.copyUrl")}>
              <Button
                variant="surface"
                size="3"
                onClick={() => {
                  navigator.clipboard
                    .writeText(window.location.href)
                    .then(() => {
                      createToast({
                        type: "success",
                        message: i18next.t("news.actions.copied"),
                      });
                    })
                    .catch(() => {
                      createToast({
                        type: "error",
                        message: i18next.t("news.actions.copyFailed"),
                      });
                    });
                }}
              >
                <CopyIcon />
              </Button>
            </Tooltip>

            {/* Share Btn */}
            {brand.hasFeature.posts && (
              <Tooltip content="Share with your friends">
                <Dialog.Trigger>
                  <Button
                    variant="surface"
                    size="3"
                    title="Share with your friends"
                    onClick={() => {
                      setShareModalOpen(true);
                    }}
                  >
                    <Share1Icon />
                  </Button>
                </Dialog.Trigger>
              </Tooltip>
            )}

            {/* Chat */}
            {brand.hasFeature.posts && (
              <Tooltip content="Leave a comment">
                <Button
                  variant="surface"
                  size="3"
                  onClick={() => scrollToComments()}
                >
                  <ChatBubbleIcon />
                </Button>
              </Tooltip>
            )}

            <SingleNewsAuthorActions
              createdBy={data.createdBy}
              slug={data.slug}
            />
          </Flex>
        </Card>
      </Flex>
    </Dialog.Root>
  );
};
